import * as React from 'react';

import { useTheme } from 'styled-components';

export interface PauseIconProps {
  className?: string;
  color?: string;
}

export const PauseIcon: React.FC<PauseIconProps> = (props) => {
  const theme = useTheme();

  const getColor = (color: any) => {
    switch (color) {
      case 'dark':
        return theme.colors.primary;
      case 'red':
        return theme.colors.accent;
      default:
        return theme.colors.primary;
    }
  };
  return (
    <svg
      width="7"
      height="8"
      viewBox="0 0 7 8"
      className={props.className}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path
        fill={getColor(props.color)}
        d="M5.5,8L5.5,8c-0.55,0-1-0.45-1-1V1c0-0.55,0.45-1,1-1h0c0.55,0,1,0.45,1,1v6C6.5,7.55,6.05,8,5.5,8z"
      />
      <path
        fill={getColor(props.color)}
        d="M1.5,8L1.5,8c-0.55,0-1-0.45-1-1V1c0-0.55,0.45-1,1-1h0c0.55,0,1,0.45,1,1v6C2.5,7.55,2.05,8,1.5,8z"
      />
    </svg>
  );
};

export default PauseIcon;
